export default __webpack_public_path__ + "static/media/battery.41fb0c42.svg";